import axios from 'axios'
import {authHeader} from '../auth'
let instance = axios.create({
  baseURL: process.env.API_URL
})

instance.interceptors.request.use((config) => {
  if (authHeader()) {
    config.headers.common['Authorization'] = authHeader()
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/api/axios.js